/**
 * Mobile-only site detection.
 *
 * The same build serves the full CRM AND a dedicated subdomain that shows ONLY
 * the mobile dashboard (route `mobileSite`, no sidebar/menu). Which mode we are
 * in is decided by the hostname against `window.config.mobileHost`
 * (public/config.js — a string or an array of hostnames).
 *
 * Testing without the subdomain: open the CRM with `?mobileSite=1` — the flag
 * sticks for the browser tab (sessionStorage); `?mobileSite=0` clears it. It
 * only changes which pages are reachable; the dashboard itself still needs the
 * MOBILE_DASHBOARD permission and the user's view code.
 */
export const MOBILE_SITE_ROUTE = 'mobileSite'

/** Idle time after which the view code must be re-entered. */
export const MOBILE_SITE_IDLE_MS = 5 * 60 * 1000

const OVERRIDE_KEY = 'mobileSite'

function configuredHosts() {
  const cfg = (typeof window !== 'undefined' && window.config) || {}
  return [].concat(cfg.mobileHost || [])
    .filter(Boolean)
    .map(h => String(h).trim().toLowerCase())
}

export function isMobileSite() {
  if (typeof window === 'undefined') return false
  const here = (window.location.hostname || '').toLowerCase()
  if (configuredHosts().includes(here)) return true
  try {
    const q = new URLSearchParams(window.location.search).get(OVERRIDE_KEY)
    if (q === '1') sessionStorage.setItem(OVERRIDE_KEY, '1')
    else if (q === '0') sessionStorage.removeItem(OVERRIDE_KEY)
    return sessionStorage.getItem(OVERRIDE_KEY) === '1'
  } catch (e) {
    return false
  }
}
